export class SwimmerRepository {
    constructor(fileStore) {
        this.fileStore = fileStore;
    }
    async initialize() {
        await this.fileStore.ensureFile({ swimmers: [] });
    }
    async save(swimmerData) {
        try {
            const data = await this.fileStore.read();
            const existingIndex = data.swimmers.findIndex(s => s.tiref === swimmerData.tiref);
            const swimmer = {
                ...swimmerData,
                lastUpdated: new Date().toISOString()
            };
            if (existingIndex >= 0) {
                data.swimmers[existingIndex] = swimmer;
            }
            else {
                data.swimmers.push(swimmer);
            }
            console.log('Datastore: writing to file', this.fileStore.getPath());
            await this.fileStore.write(data);
            console.log('Datastore: file written successfully');
            return swimmer;
        }
        catch (error) {
            console.error('Datastore: Error saving swimmer', error);
            throw error;
        }
    }
    async findAll() {
        await this.fileStore.ensureFile({ swimmers: [] });
        const data = await this.fileStore.read();
        const swimmers = data.swimmers || [];
        for (const swimmer of swimmers) {
            const legacy = swimmer;
            if (legacy.group && !swimmer.tags) {
                swimmer.tags = [legacy.group];
                delete legacy.group;
            }
        }
        return swimmers;
    }
    async findByTiref(tiref) {
        await this.fileStore.ensureFile({ swimmers: [] });
        const data = await this.fileStore.read();
        return data.swimmers.find(s => s.tiref === tiref) || null;
    }
    async replaceAll(swimmers) {
        await this.fileStore.write({ swimmers });
    }
    async clear() {
        await this.fileStore.clear();
    }
    async deleteByTiref(tiref) {
        await this.fileStore.ensureFile({ swimmers: [] });
        const data = await this.fileStore.read();
        const initialLength = data.swimmers.length;
        data.swimmers = data.swimmers.filter(s => s.tiref !== tiref);
        if (data.swimmers.length < initialLength) {
            await this.fileStore.write(data);
            return true;
        }
        return false;
    }
}
